export default __webpack_public_path__ + "static/media/route-marker.0adba7ae.svg";